import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

var store = new Vuex.Store({
    state: {
        user: {
            admin_access: false,
            admins_manage: false,
            company: {
              data: {
              }
            }
        },
        token: (localStorage!==null)?localStorage.token:null,
        companies: {},
    },

    getters: {
        gettingStartedArticle(state) {
            var articles = {
                'de':    '/app/training/news/item/460',
                'en':    '/app/training/news/item/459',
                'es':    '/app/training/news/item/804',
                'es-es': '/app/training/news/item/804',
                'fr':    '/app/training/news/item/461',
                'id':    '/app/training/news/item/793',
                'it':    '/app/training/news/item/802',
                'ja':    '/app/training/news/item/773',
                'ko':    '/app/training/news/item/803',
                'pt':    '/app/training/news/item/779',
                'pt-br': '/app/training/news/item/794',
                'ru':    '/app/training/news/item/776',
                'tr':    '/app/training/news/item/806',
                'ms':    '/app/training/news/item/2293',
                'nl':    '/app/training/news/item/1759',
            };
            return articles[state.user.language_id] || articles.en;
        },
        createAFacebookGroupArticle(state) {
            var articles = {
                'de':    '/app/training/course/16/lesson/49',
                'en':    '/app/training/course/18/lesson/59',
                'es':    '/app/training/course/39/lesson/681',
                'es-es': '/app/training/course/39/lesson/681',
                'fr':    '/app/training/course/45/lesson/678',
                'id':    '/app/training/course/102/lesson/1710',
                'it':    '/app/training/course/203/lesson/1027',
                'ja':    '/app/training/course/178/lesson/979',
                'ko':    '/app/training/course/237/lesson/838',
                'pt':    '/app/training/course/119/lesson/1233',
                'pt-br': '/app/training/course/119/lesson/1233',
                'ru':    '/app/training/course/153/lesson/1471',
                'tr':    '/app/training/course/221/lesson/1116',
                'ms':    '/app/training/course/297/lesson/2292',
                'nl':    '/app/training/course/253/lesson/1460',
            };
            return articles[state.user.language_id] || articles.en;
        },
        createAFacebookPageArticle(state) {
            var articles = {
                'de':    '/app/training/course/26/lesson/212',
                'en':    '/app/training/course/23/lesson/128',
                'es':    '/app/training/course/38/lesson/484',
                'es-es': '/app/training/course/38/lesson/484',
                'fr':    '/app/training/course/44/lesson/2291',
                'id':    '/app/training/course/101/lesson/1264',
                'it':    '/app/training/course/202/lesson/1015',
                'ja':    '/app/training/course/176/lesson/967',
                'ko':    '/app/training/course/236/lesson/826',
                'pt':    '/app/training/course/136/lesson/1091',
                'pt-br': '/app/training/course/136/lesson/1091',
                'ru':    '/app/training/course/152/lesson/1413',
                'tr':    '/app/training/course/219/lesson/1087',
                'ms':    '/app/training/course/296/lesson/2167',
                'nl':    '/app/training/course/252/lesson/1434',
            };
            return articles[state.user.language_id] || articles.en;
        },
        instagramLinkingArticle(state) {
            var articles = {
                'de':    '/app/training/course/28/lesson/2370',
                'en':    '/app/training/course/1/lesson/2250',
                'es':    '/app/training/course/35/lesson/2350',
                'es-es': '/app/training/course/35/lesson/2350',
                'fr':    '/app/training/course/48/lesson/2332',
                'id':    '/app/training/course/110/lesson/2359',
                'it':    '/app/training/course/211/lesson/2342',
                'ja':    '/app/training/course/186/lesson/2356',
                'ko':    '/app/training/course/245/lesson/2387',
                'pt':    '/app/training/course/145/lesson/2337',
                'pt-br': '/app/training/course/145/lesson/2337',
                'ru':    '/app/training/course/161/lesson/2353',
                'tr':    '/app/training/course/229/lesson/2340',
                'ms':    '/app/training/course/305/lesson/2362',
                'nl':    '/app/training/course/261/lesson/2347'
            };
            return articles[state.user.language_id] || articles.en;
        },
        instagramConversionArticle(state) {
            var articles = {
                'de':    '/app/training/course/28/lesson/222',
                'en':    '/app/training/course/1/lesson/1',
                'es':    '/app/training/course/35/lesson/479',
                'es-es': '/app/training/course/35/lesson/479',
                'fr':    '/app/training/course/48/lesson/2386',
                'id':    '/app/training/course/110/lesson/1472',
                'it':    '/app/training/course/211/lesson/1269',
                'ja':    '/app/training/course/186/lesson/2355',
                'ko':    '/app/training/course/245/lesson/908',
                'pt':    '/app/training/course/145/lesson/1444',
                'pt-br': '/app/training/course/134/lesson/2542',
                'ru':    '/app/training/course/161/lesson/1815',
                'tr':    '/app/training/course/229/lesson/2341',
                'ms':    '/app/training/course/305/lesson/2232',
                'nl':    '/app/training/course/261/lesson/2348'
            };
            return articles[state.user.language_id] || articles.en;
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setConnections(state, connections) {
            state.user.connections = {data: connections};
        },
    }
});

module.exports = store;


// WEBPACK FOOTER //
// ./resources/assets/js/stores/store.js